var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "v-toolbar",
            {
              staticStyle: { "padding-top": "50px" },
              attrs: { dense: "", extended: "", color: "primary", dark: "" },
            },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", "pa-5": "" } },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass: "display-2",
                      attrs: { slot: "extension" },
                      slot: "extension",
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: { "padding-bottom": "10px" },
                          attrs: { "x-large": "" },
                        },
                        [_vm._v("settings")]
                      ),
                      _vm._v("\n          Ingestion Configurations\n        "),
                    ],
                    1
                  ),
                  _vm._v(
                    "\n        Manage continuous data ingestion configurations.\n        "
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mt-2",
                      attrs: {
                        flat: "",
                        dark: "",
                        to: { name: "ingestionDashboard" },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("arrow_back"),
                      ]),
                      _vm._v("Back to Dashboard\n        "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", "pa-3": "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", dark: "" },
                      on: { click: _vm.openAdd },
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [_vm._v("add")]),
                      _vm._v("Add Configuration\n        "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.configurations,
                  loading: _vm.loading,
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function (props) {
                      return [
                        _c("td", [_vm._v(_vm._s(props.item.Name))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(props.item.StationId))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.dataSourceLabel(props.item.DataSourceType)
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c(
                              "v-chip",
                              {
                                attrs: {
                                  color: props.item.IsActive
                                    ? "success"
                                    : "default",
                                  small: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      props.item.IsActive
                                        ? "Active"
                                        : "Inactive"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.formatDate(props.item.UpdatedAt))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-right" },
                          [
                            props.item.DataSourceType !== "6"
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      small: "",
                                      color: "success",
                                      depressed: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.runNow(props.item)
                                      },
                                    },
                                  },
                                  [_vm._v("Run Now")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            props.item.DataSourceType !== "6"
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      small: "",
                                      color: "primary",
                                      depressed: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openSchedule(props.item)
                                      },
                                    },
                                  },
                                  [_vm._v("Schedule")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  small: "",
                                  color: "info",
                                  depressed: "",
                                  to: {
                                    name: "ingestionJobs",
                                    query: { configId: props.item.Id },
                                  },
                                },
                              },
                              [_vm._v("Jobs")]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  small: "",
                                  color: "warning",
                                  depressed: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openEdit(props.item)
                                  },
                                },
                              },
                              [_vm._v("Edit")]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { small: "", color: "error" },
                                on: {
                                  click: function ($event) {
                                    return _vm.confirmDelete(props.item)
                                  },
                                },
                              },
                              [_vm._v("Delete")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600", persistent: "" },
          model: {
            value: _vm.showDialog,
            callback: function ($$v) {
              _vm.showDialog = $$v
            },
            expression: "showDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(_vm.isEdit ? "Edit" : "Add") + " Configuration"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "pt-3" },
                [
                  _c(
                    "v-form",
                    { ref: "form", attrs: { "lazy-validation": "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Configuration Name",
                          rules: [_vm.rules.required],
                          required: "",
                        },
                        model: {
                          value: _vm.form.Name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "Name", $$v)
                          },
                          expression: "form.Name",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          label: "Aquarius Station Name",
                          rules: [_vm.rules.required],
                          required: "",
                        },
                        model: {
                          value: _vm.form.StationId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "StationId", $$v)
                          },
                          expression: "form.StationId",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          label: "Data Source Type",
                          items: _vm.dataSourceTypes,
                          "item-value": "value",
                          "item-text": "text",
                          disabled: _vm.isEdit,
                          rules: [_vm.rules.required],
                          required: "",
                        },
                        model: {
                          value: _vm.form.DataSourceType,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "DataSourceType", $$v)
                          },
                          expression: "form.DataSourceType",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "v-alert",
                        {
                          staticClass: "mb-3",
                          attrs: { type: "warning", outline: "", value: true },
                        },
                        [
                          _vm._v(
                            "\n            Once saved, the configuration type cannot be changed. To use a different type, create a new configuration.\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.form.DataSourceType !== "6" &&
                      _vm.form.DataSourceType !== "7"
                        ? _c("v-textarea", {
                            attrs: {
                              label: "Detail Settings (JSON)",
                              hint: "JSON string with source-specific settings",
                            },
                            model: {
                              value: _vm.form.DetailSettings,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "DetailSettings", $$v)
                              },
                              expression: "form.DetailSettings",
                            },
                          })
                        : _vm.form.DataSourceType === "6"
                        ? [
                            _c(
                              "v-alert",
                              {
                                staticClass: "mb-3",
                                attrs: {
                                  type: "info",
                                  outline: "",
                                  value: true,
                                },
                              },
                              [
                                _vm._v(
                                  '\n              Station Photos is for UI photo upload and API upload only. "Run Now" and "Schedule" are disabled for this type. Use "FTP Station Photos" for scheduled FTP-based photo ingestion.\n            '
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: {
                                label: "Directory Name (optional)",
                                hint: "Azure Blob virtual directory path. Defaults to station name.",
                              },
                              model: {
                                value: _vm.photoSettings.directoryName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.photoSettings,
                                    "directoryName",
                                    $$v
                                  )
                                },
                                expression: "photoSettings.directoryName",
                              },
                            }),
                            _vm._v(" "),
                            _c("v-checkbox", {
                              attrs: {
                                label: "Should Overwrite Existing Blobs",
                              },
                              model: {
                                value: _vm.photoSettings.shouldOverride,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.photoSettings,
                                    "shouldOverride",
                                    $$v
                                  )
                                },
                                expression: "photoSettings.shouldOverride",
                              },
                            }),
                          ]
                        : [
                            _c("v-text-field", {
                              attrs: {
                                label: "Directory Name (optional)",
                                hint: "Azure Blob virtual directory path. Defaults to station name.",
                              },
                              model: {
                                value: _vm.ftpPhotoSettings.directoryName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ftpPhotoSettings,
                                    "directoryName",
                                    $$v
                                  )
                                },
                                expression: "ftpPhotoSettings.directoryName",
                              },
                            }),
                            _vm._v(" "),
                            _c("v-checkbox", {
                              attrs: {
                                label: "Should Overwrite Existing Blobs",
                              },
                              model: {
                                value: _vm.ftpPhotoSettings.shouldOverride,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ftpPhotoSettings,
                                    "shouldOverride",
                                    $$v
                                  )
                                },
                                expression: "ftpPhotoSettings.shouldOverride",
                              },
                            }),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: {
                                label: "FTP URL",
                                rules: [_vm.rules.required],
                                required: "",
                              },
                              model: {
                                value: _vm.ftpPhotoSettings.ftpUrl,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ftpPhotoSettings, "ftpUrl", $$v)
                                },
                                expression: "ftpPhotoSettings.ftpUrl",
                              },
                            }),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: { label: "FTP Port", type: "number" },
                              model: {
                                value: _vm.ftpPhotoSettings.ftpPort,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ftpPhotoSettings, "ftpPort", $$v)
                                },
                                expression: "ftpPhotoSettings.ftpPort",
                              },
                            }),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: {
                                label: "FTP Username",
                                rules: [_vm.rules.required],
                                required: "",
                              },
                              model: {
                                value: _vm.ftpPhotoSettings.ftpUsername,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ftpPhotoSettings,
                                    "ftpUsername",
                                    $$v
                                  )
                                },
                                expression: "ftpPhotoSettings.ftpUsername",
                              },
                            }),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: {
                                label: "FTP Password",
                                type: "password",
                                rules: [_vm.rules.required],
                                required: "",
                              },
                              model: {
                                value: _vm.ftpPhotoSettings.ftpPassword,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ftpPhotoSettings,
                                    "ftpPassword",
                                    $$v
                                  )
                                },
                                expression: "ftpPhotoSettings.ftpPassword",
                              },
                            }),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: {
                                label: "Filter Directories",
                                hint: "Comma-separated list of directories to filter",
                              },
                              model: {
                                value: _vm.ftpPhotoSettings.filterDirectories,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ftpPhotoSettings,
                                    "filterDirectories",
                                    $$v
                                  )
                                },
                                expression:
                                  "ftpPhotoSettings.filterDirectories",
                              },
                            }),
                          ],
                      _vm._v(" "),
                      _c("v-checkbox", {
                        attrs: { label: "Active" },
                        model: {
                          value: _vm.form.IsActive,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "IsActive", $$v)
                          },
                          expression: "form.IsActive",
                        },
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "secondary", outline: "" },
                      on: { click: _vm.closeDialog },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", dark: "" },
                      on: { click: _vm.save },
                    },
                    [_vm._v("Save")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "400" },
          model: {
            value: _vm.showDeleteDialog,
            callback: function ($$v) {
              _vm.showDeleteDialog = $$v
            },
            expression: "showDeleteDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "error" } },
                [_c("v-toolbar-title", [_vm._v("Confirm Delete")])],
                1
              ),
              _vm._v(" "),
              _c("v-card-text", { staticClass: "pt-3" }, [
                _vm._v(
                  'Are you sure you want to delete "' +
                    _vm._s(_vm.deleteTarget ? _vm.deleteTarget.Name : "") +
                    '"?'
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { outline: "" },
                      on: {
                        click: function ($event) {
                          _vm.showDeleteDialog = false
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    { attrs: { color: "error" }, on: { click: _vm.doDelete } },
                    [_vm._v("Delete")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "700", persistent: "" },
          model: {
            value: _vm.showScheduleDialog,
            callback: function ($$v) {
              _vm.showScheduleDialog = $$v
            },
            expression: "showScheduleDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(
                      "Schedule Assignment for " +
                        _vm._s(
                          _vm.scheduleTarget ? _vm.scheduleTarget.Name : ""
                        )
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "pt-3" },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs5: "" } },
                        [
                          _c("v-subheader", [_vm._v("Available Schedules")]),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            [
                              _vm._l(_vm.availableSchedules, function (s) {
                                return _c(
                                  "v-list-tile",
                                  {
                                    key: s.Id,
                                    on: {
                                      click: function ($event) {
                                        return _vm.addConfigToSchedule(s)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-list-tile-content",
                                      [
                                        _c("v-list-tile-title", [
                                          _vm._v(_vm._s(s.Name)),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-list-tile-sub-title", [
                                          _c("code", [
                                            _vm._v(_vm._s(s.CronExpression)),
                                          ]),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-tile-action",
                                      [
                                        _c(
                                          "v-btn",
                                          { attrs: { icon: "" } },
                                          [
                                            _c("v-icon", [
                                              _vm._v("add_circle"),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              _vm._v(" "),
                              _vm.availableSchedules.length === 0
                                ? _c(
                                    "v-list-tile",
                                    [
                                      _c(
                                        "v-list-tile-content",
                                        [
                                          _c(
                                            "v-list-tile-title",
                                            { staticClass: "grey--text" },
                                            [_vm._v("No schedules available")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "text-xs-center", attrs: { xs2: "" } },
                        [
                          _c("v-icon", { attrs: { large: "" } }, [
                            _vm._v("arrow_forward"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs5: "" } },
                        [
                          _c("v-subheader", [_vm._v("Assigned Schedules")]),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            [
                              _vm._l(_vm.assignedSchedules, function (s) {
                                return _c(
                                  "v-list-tile",
                                  {
                                    key: s.Id,
                                    on: {
                                      click: function ($event) {
                                        return _vm.onRemoveSchedule(s)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-list-tile-content",
                                      [
                                        _c("v-list-tile-title", [
                                          _vm._v(_vm._s(s.Name)),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-list-tile-sub-title", [
                                          _c("code", [
                                            _vm._v(_vm._s(s.CronExpression)),
                                          ]),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-tile-action",
                                      [
                                        _c(
                                          "v-btn",
                                          { attrs: { icon: "" } },
                                          [
                                            _c("v-icon", [
                                              _vm._v("remove_circle"),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              _vm._v(" "),
                              _vm.assignedSchedules.length === 0
                                ? _c(
                                    "v-list-tile",
                                    [
                                      _c(
                                        "v-list-tile-content",
                                        [
                                          _c(
                                            "v-list-tile-title",
                                            { staticClass: "grey--text" },
                                            [_vm._v("No schedules assigned")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "secondary", outline: "" },
                      on: { click: _vm.cancelScheduleDialog },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        dark: "",
                        loading: _vm.savingSchedules,
                      },
                      on: { click: _vm.saveScheduleAssignments },
                    },
                    [_vm._v("Save")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: { color: _vm.snackColor, timeout: 6000, top: "" },
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.snackMessage) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              on: {
                click: function ($event) {
                  _vm.snackbar = false
                },
              },
            },
            [_vm._v("Close")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }